/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ "\"starter_monthly\"": NonNullable<unknown> }} Admin_Settings_Placeholders_Creem_Product_Ids_MappingInputs */

const en_admin_settings_placeholders_creem_product_ids_mapping = /** @type {(inputs: Admin_Settings_Placeholders_Creem_Product_Ids_MappingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.["\"starter_monthly\""]}`)
};

/**
* | output |
* | --- |
* | "{\"starter_monthly\"}" |
*
* @param {Admin_Settings_Placeholders_Creem_Product_Ids_MappingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_placeholders_creem_product_ids_mapping = /** @type {((inputs: Admin_Settings_Placeholders_Creem_Product_Ids_MappingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Placeholders_Creem_Product_Ids_MappingInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_placeholders_creem_product_ids_mapping(inputs)
});
export { admin_settings_placeholders_creem_product_ids_mapping as "admin.settings.placeholders.creem_product_ids_mapping" }